import {evolve, omit} from 'ramda';
import {replace} from 'utils/objects';
import initState from './state';
import {parseNullableNumber, parseNullableString} from 'utils/fields';
import {TABS} from './constants';

export const parseUrlQuery = query => {
	const vals = evolve(
		{
			_page: Number,
			tab: parseNullableString,
			marketingSourceId: parseNullableNumber,
			marketingCategoryId: parseNullableNumber,
			marketingCustomerTypeId: parseNullableNumber,
			phone: parseNullableString,
			clientName: parseNullableString,
		},
		query,
	);

	return {leadsQuery: replace(vals, initState.leadsQuery)};
};

export const formatFetchableLeadsQuery = ({
	leadsQuery,
	userId,
	organizationId,
	canReadAllLeads,
	canReadAllOrganizationLeads,
}) => {
	let query = {};
	if (leadsQuery.tab === TABS.ALL && canReadAllLeads) {
		query = leadsQuery;
	} else if (leadsQuery.tab === TABS.ALL_ORGANIZATION && canReadAllOrganizationLeads) {
		query = {
			...leadsQuery,
			organizationId,
		};
	} else if (leadsQuery.tab === TABS.OWNER) {
		query = {...leadsQuery, ownerId: userId};
	} else {
		query = {...leadsQuery, userId};
	}

	return omit(['tab'], query);
};
